import type { ReactElement } from 'react';
import { useState } from 'react';

import { monthDay } from 'utils/dateTimes';
import UpcomingMenu from 'models/UpcomingMenu';

import { Component as SuccessIcon } from 'icons/icon-mktg--check-shadow.svg';
import Modal from 'components/shared/Modal';

type Props = {
  upcomingMenu?: UpcomingMenu;
};

function OrderConfirmationModal({ upcomingMenu }: Props): ReactElement {
  const [show, setShow] = useState(true);
  const meals = upcomingMenu?.mealSummary;
  // @ts-expect-error TODO: fix null safety
  const date = monthDay(upcomingMenu?.delivery_on);

  return (
    <Modal
      show={show}
      onClose={() => setShow(false)}
      wrapperClassName="c-modal-confirmation"
      className="modal-dialog-centered"
      body={(
        <>
          <Modal.CloseBtn onClick={() => setShow(false)} />

          <div className="c-modal-confirmation__content">
            <SuccessIcon />
            <h3 className="c-heading c-heading--brand-4">
              You’re All Set!
            </h3>
            {meals && date && (
              <div>
                {`You’ll receive ${meals} on ${date}.`}
              </div>
            )}
          </div>
        </>
      )}
    />
  );
}

export default OrderConfirmationModal;
